module.exports = __webpack_public_path__ + "static/media/Yvette L.e90d8eff.png";